module.exports = __webpack_public_path__ + "static/icon-6d379dc7b6bcccfa6c9dcedb6efb323a.jpg";